// removed by extract-text-webpack-plugin
module.exports = {"bg":"_3OTPz","base":"_--6GQ","sectionHeader":"_38Ogb","title":"_3vfUN","content":"_3CQFR","spinner":"_7dqQW","list":"_2LuD5","fieldset":"_2KA-G","form":"_3u9nu","group":"_1heUz","footer":"GYaXA"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/PartnerPlanAdminOverviewDisplayForm.scss
// module id = 2678
// module chunks = 0